import { contingencyEventApi } from "../../api";
import { ContingencyEventFilter } from "../../types/dte/contingency/ContingencyEventFilter";


const ContingencyEventService = {

  /**
   * 🔍 Listado filtrado y paginado
   * POST /api/dte/contingencies/filtered?page=x&size=y&sort=status,desc
   */
  getFiltered: async (
    filters: ContingencyEventFilter,
    page = 0,
    size = 10,
    sort = "startTimestamp,desc"
  ) => {
    const response = await contingencyEventApi.addCustom(
      `/filtered?page=${page}&size=${size}&sort=${sort}`,
      filters
    );
    return response.data; // Retorna CustomResponse<Page<ContingencyEventTableDTO>>
  },

  /**
   * 📄 Detalle por ID
   * GET /api/dte/contingencies/{id}
   */
  getById: async (id: number) => {
    const response = await contingencyEventApi.fetchById(id);
    return response.data; // Retorna CustomResponse<ContingencyEventDetailDTO>
  },

};

export default ContingencyEventService;
